import { render, staticRenderFns } from "./Dealer.vue?vue&type=template&id=6975d734&scoped=true"
import script from "./Dealer.vue?vue&type=script&lang=js"
export * from "./Dealer.vue?vue&type=script&lang=js"
import style0 from "./Dealer.vue?vue&type=style&index=0&id=6975d734&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975d734",
  null
  
)

export default component.exports